module.exports = __webpack_public_path__ + "img/vue1-semelle_blanc.40140754.png";